import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const MarkdownComponent = ({ children }) => {
  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      components={{
        a: ({ node, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer">
            {props.children}
          </a>
        ),
      }}
    >
      {children}
    </Markdown>
  );
};

export default MarkdownComponent;
